import { getEnumObjectProp, getKeys } from '../../../utils';
import { formatDate } from '../../../utils/date';
import { attributeTypes } from '../../../utils/search';

export function radioOptionButtons(radioButtons) {
  let data = [];
  getKeys(radioButtons)?.forEach((item) =>
    data.push({
      key: radioButtons[item].index,
      value: radioButtons[item].value,
      label: radioButtons[item].text,
    })
  );
  return data;
}

export function filterAttributeStatuses(enums, attribute) {
  let filterStatus = [];
  getKeys(enums)?.forEach((item) => {
    if (enums[item]?.type?.indexOf(attribute?.type.toLowerCase()) > -1) {
      filterStatus.push(item);
    }
  });
  return filterStatus;
}

export function fullFilterCriteria(
  enums,
  radioButtonEnums,
  firstFilter,
  radioButton,
  secondFilter
) {
  return `${getEnumObjectProp(enums, firstFilter)} ${toLowerText(
    getEnumObjectProp(radioButtonEnums, radioButton)
  )} ${getEnumObjectProp(enums, secondFilter)}`;
}

export function validNumber(filter) {
  var isValid = true;
  if (
    /[!@#$%^&*(),?":{}|<>]/g.test(filter) ||
    /[a-z]/g.test(filter) ||
    /[A-Z]/g.test(filter)
  ) {
    isValid = false;
  }
  return isValid;
}

export function getFirstRadioButton(enums) {
  return enums[getKeys(enums)[0]];
}

export function changeDateFilterInput(
  radioButtons,
  firstInput,
  radioOption,
  secondInput
) {
  let dateFilter = '';
  if (firstInput) {
    dateFilter = dateFilter.concat(formatDate(firstInput));
  }
  if (secondInput) {
    dateFilter = dateFilter.concat(
      ' ' +
        getEnumObjectProp(radioButtons, radioOption)?.toLowerCase() +
        ' ' +
        formatDate(secondInput)
    );
  }
  return dateFilter;
}

export function toLowerText(text) {
  return text?.toLowerCase() || '';
}

export const mapFilters = (attributeStates, Errors, AttributeFilters) => {
  return attributeStates?.map((filter) => {
    let error = null;
    if (
      !filter.firstInput &&
      filter?.attribute?.type !== attributeTypes.BOOLEAN &&
      !emptyNotEmpty(AttributeFilters, filter.firstCriteria)
    ) {
      error = Errors.missingCriteria;
    } else {
      switch (filter.attribute.type) {
        case attributeTypes.NUMBER:
          if (filter.firstCriteria === AttributeFilters.IN_RANGE.value) {
            if (!filter.firstInputRange) {
              error = Errors.missingNumberTo;
            } else if (filter.firstInputRange < filter.firstInput) {
              error = Errors.numberToLess;
            }
          }
          if (filter.secondCriteria === AttributeFilters.IN_RANGE.value) {
            if (
              filter.secondInputRange &&
              filter.secondInputRange < filter.secondInput
            ) {
              error = Errors.numberToLess;
            } else if (!filter.secondInputRange) {
              filter.secondCriteria = null;
              filter.secondInput = null;
            }
          }
          break;
        case attributeTypes.TEXT:
          if (emptyNotEmpty(AttributeFilters, filter.firstCriteria)) {
            filter.firstInput = null;
          }
          if (emptyNotEmpty(AttributeFilters, filter.secondCriteria)) {
            filter.secondInput = null;
          }
          break;
        default:
          break;
      }
    }
    filter = { ...filter, error: error };
    return filter;
  });
};

export const prepareCriteriaForBE = (AttributeFilters, criteria) => {
  const mainCriteria =
    criteria.secondInput ||
    emptyNotEmpty(AttributeFilters, criteria.secondCriteria);
  const radioOptionCondition = mainCriteria ? criteria.radioOption : null;
  const secondCriteriaCondition = mainCriteria ? criteria.secondCriteria : null;
  if (criteria.attribute.type === attributeTypes.BOOLEAN) {
    return {
      key: criteria.attribute.field,
      operation: criteria.firstCriteria,
      value: null,
      conjunction: null,
      operation2: null,
      value2: null,
    };
  }
  return {
    key: criteria.attribute.field,
    operation: criteria.firstCriteria,
    value: criteria.firstInputRange
      ? `${criteria.firstInput},${criteria.firstInputRange}`
      : criteria.firstInput,
    conjunction: radioOptionCondition,
    operation2: secondCriteriaCondition,
    value2: criteria.secondInputRange
      ? `${criteria.secondInput},${criteria.secondInputRange}`
      : criteria.secondInput,
  };
};

export function disableInput(enums, state) {
  const { attribute, firstCriteria, firstInput, firstInputRange, secondInput } =
    state || {};
  return (
    attribute?.type === attributeTypes.DATE ||
    attribute.type === attributeTypes.OBJECT ||
    emptyNotEmpty(enums, firstCriteria) ||
    (firstCriteria === enums.IN_RANGE.value &&
      !!firstInput &&
      !!firstInputRange) ||
    !!secondInput
  );
}

export function generateLabel(enums, radioButtons, state) {
  const {
    firstCriteria,
    radioOption,
    secondCriteria,
    secondInput,
    secondInputRange,
  } = state || {};

  if (
    emptyNotEmpty(enums, secondCriteria) ||
    secondInput ||
    (secondCriteria === enums.IN_RANGE.value && secondInput && secondInputRange)
  ) {
    return fullFilterCriteria(
      enums,
      radioButtons,
      firstCriteria,
      radioOption,
      secondCriteria
    );
  } else {
    return getEnumObjectProp(enums, firstCriteria);
  }
}

export function generateInput(enums, radioButtonEnums, state, Placeholders) {
  const {
    firstCriteria,
    firstInput,
    firstInputRange,
    secondInput,
    secondCriteria,
    radioOption,
    secondInputRange,
  } = state || {};

  let criteriaInput = '';
  let first = '';
  let second = '';
  if (
    !emptyNotEmpty(enums, firstCriteria) &&
    firstInput &&
    firstCriteria !== enums.IN_RANGE.value
  ) {
    first = `${firstInput}`;
  }

  if (firstCriteria === enums.IN_RANGE.value && firstInput && firstInputRange) {
    first = `${toLowerText(Placeholders.from)} ${firstInput} ${toLowerText(
      Placeholders.to
    )} ${firstInputRange}`;
  }
  if (
    !emptyNotEmpty(enums, secondCriteria) &&
    secondInput &&
    secondCriteria !== enums.IN_RANGE.value
  ) {
    second = `${secondInput}`;
  }
  if (
    secondCriteria === enums.IN_RANGE.value &&
    secondInput &&
    secondInputRange
  ) {
    second = `${toLowerText(Placeholders.from)} ${secondInput} ${toLowerText(
      Placeholders.to
    )} ${secondInputRange}`;
  }
  if (first && second) {
    criteriaInput = `${first} ${toLowerText(
      getEnumObjectProp(radioButtonEnums, radioOption)
    )} ${second}`;
  } else if (first && !second) {
    criteriaInput = `${first}`;
  } else if (!first && second) {
    criteriaInput = `${second}`;
  }
  return criteriaInput;
}

export const emptyNotEmpty = (enums, criteria) => {
  return criteria === enums.EMPTY.value || criteria === enums.NOT_EMPTY.value;
};
